import React from 'react';
import '../../styles/PageCommon.css';

export default function NotificationsPage() {
  const alerts = [
    { title: 'New forecast available', detail: 'Dashboard updated with latest ML run', priority: 'High' },
    { title: 'Delayed shipment', detail: 'PO-18341 ETA pushed by 1 day', priority: 'Medium' },
    { title: 'Low stock alert', detail: 'СКЮ-1044 below safety stock', priority: 'High' },
    { title: 'Report ready', detail: 'Monthly Performance report generated', priority: 'Low' },
  ];

  return (
    <div className="page-content">
      <div className="chart-card">
        <div className="chart-header">
          <div>
            <h2 className="chart-title">Notifications</h2>
            <p className="chart-subtitle">Latest alerts and updates</p>
          </div>
        </div>

        <div className="legend-section">
          <div className="legend-grid">
            {alerts.map((alert) => (
              <div key={alert.title} className="legend-item">
                <div
                  className={`legend-dot ${
                    alert.priority === 'High' ? 'red-dot' : alert.priority === 'Medium' ? 'orange-dot' : 'green-dot'
                  }`}
                ></div>
                <div>
                  <p className="legend-name">
                    {alert.title} · {alert.priority} priority
                  </p>
                  <p className="legend-desc">{alert.detail}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

